import React from 'react';

export const COLOUR2 = {
  BLUE: '#072241',
  WHITE: '#ffffff',
};
const IconProperties = () => {
  return (
    <svg
      width="39"
      height="31"
      viewBox="0 0 39 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.06055 29.9881V26.0751C8.06055 24.7791 9.11155 23.7271 10.4075 23.7271C11.7045 23.7271 12.7565 24.7791 12.7565 26.0751V29.9881"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.92969 20.8818V29.9878H15.8867V20.8818"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.79883 23.7274L9.35983 16.8544C9.95583 16.3154 10.8628 16.3154 11.4598 16.8544L18.2338 22.9454"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4512 14.3357V10.4227C17.4512 9.12668 18.5012 8.07568 19.7992 8.07568C21.0952 8.07568 22.1462 9.12668 22.1462 10.4227V14.3357"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3203 5.22998V14.336H25.2763V5.22998"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1895 8.07557L18.7455 1.20657C19.3425 0.663566 20.2545 0.663566 20.8525 1.20657L28.4075 8.07557"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.8418 29.9881V26.0751C26.8418 24.7791 27.8938 23.7271 29.1898 23.7271C30.4868 23.7271 31.5378 24.7791 31.5378 26.0751V29.9881"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.7129 20.8818V29.9878H34.6689V20.8818"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3633 22.945L28.1373 16.841C28.7333 16.301 29.6403 16.301 30.2373 16.841L37.7983 23.727"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconProperties;
